/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IPais from 'Infotrack@Modelos/administracion/pais/entidades/pais';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IPais>> => [
    {
        title: formatMessage({ id: 'pais.codigoPais' }),
        field: 'CodigoPais',
    },
    {
        title: formatMessage({ id: 'pais.nombrePais' }),
        field: 'NombrePais',
    },
    {
        title: formatMessage({ id: 'pais.estadoPais' }),
        field: 'EstadoPais',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, pais?: IPais) => void,
    cargarPais: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (pais: IPais) => void
): Array<Action<IPais>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IPais),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarPais,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IPais),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IPais> = {
    maxBodyHeight: '50vh',
};
